/* =========================================================================
   QUICK PRO — paint-swatch colors + interaction (revamp B)
   -------------------------------------------------------------------------
   PRIMARY: color each dot from the theme's own paint map
   (window.MinimogSettings._colorSwatches / _imageSwatches) — the same source
   the stock swatches use, so colors (pink, blue, two-tone images) read true.
   FALLBACK: for paints not in the map (special editions), derive the color
   from the variant image via canvas (ported from SSPADE useSwatchColor).
   INTERACTION: clicking a dot swaps the card image to that variant in place
   (like the stock swatches) and marks it selected; the dot is still a real
   link for accessibility / middle-click.
   ========================================================================= */
(function () {
  var cache = new Map();

  // Render up to 3 extracted frame colors as a segmented dot (as-is, no blend):
  // 1 color -> solid, 2 -> half/half (1 divider), 3 -> thirds (2 dividers).
  function toBg(res) {
    var cols = (res && res.colors) || [];
    if (!cols.length) return null;
    if (cols.length === 1) return cols[0];
    // VERTICAL split (left/right bands) with a crisp hairline seam — reads as a
    // paint sample. (Diagonal looked like a sold-out strikethrough.)
    var n = cols.length, w = 100 / n, hw = 0.8, hair = 'rgba(255,255,255,.85)', parts = [];
    for (var i = 0; i < n; i++) {
      var s = i * w, e = (i + 1) * w;
      parts.push(cols[i] + ' ' + (i === 0 ? s : s + hw) + '% ' + (i === n - 1 ? e : e - hw) + '%');
      if (i < n - 1) parts.push(hair + ' ' + (e - hw) + '% ' + (e + hw) + '%');
    }
    return 'linear-gradient(90deg, ' + parts.join(', ') + ')';
  }

  /* ---- 1. The theme paint map (correct hex / swatch image per color name) -- */
  function colorFromMap(name) {
    var s = window.MinimogSettings || {};
    var n = (name || '').toLowerCase().trim();
    if (!n) return null;
    var im = s._imageSwatches || [];
    for (var i = 0; i < im.length; i++) { if (im[i].key === n && im[i].value) return { image: im[i].value }; }
    var co = s._colorSwatches || [];
    for (var j = 0; j < co.length; j++) { if (co[j].key === n && co[j].value) return { color: co[j].value }; }
    return null;
  }

  /* ---- 2. Fallback: extract dominant paint color from the variant image ---- */
  function tinyUrl(url) { return url.split('?')[0] + '?width=32&height=32&crop=center'; }
  function extract(url) {
    if (cache.has(url)) return Promise.resolve(cache.get(url));
    return new Promise(function (resolve) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var size = 32, c = document.createElement('canvas');
          c.width = size; c.height = size;
          var ctx = c.getContext('2d');
          if (!ctx) { resolve(null); return; }
          ctx.drawImage(img, 0, 0, size, size);
          var data = ctx.getImageData(0, 0, size, size).data;
          function dist(a, b) { return Math.sqrt(Math.pow(a[0]-b[0],2)+Math.pow(a[1]-b[1],2)+Math.pow(a[2]-b[2],2)); }
          function rgb(p) { return 'rgb(' + p[0] + ',' + p[1] + ',' + p[2] + ')'; }
          // Pull the FRAME's top 2-3 dominant colors and keep them AS-IS (no blend).
          // 1) bucket pixels (16 levels/channel), weighting chromatic paint over grey,
          //    dropping the white photo bg + black tires.
          var buckets = {}, totalW = 0;
          for (var i = 0; i < data.length; i += 4) {
            var r = data[i], g = data[i + 1], b = data[i + 2], a = data[i + 3];
            if (a < 80) continue;
            var mx = Math.max(r, g, b), mn = Math.min(r, g, b), chroma = mx - mn;
            if (chroma < 18 && (mx > 240 || mx < 18)) continue;   // white bg + black tires
            var sat = mx ? chroma / mx : 0, w = 0.12 + sat * sat * 4;
            var key = (r >> 4) + '.' + (g >> 4) + '.' + (b >> 4);
            var bk = buckets[key] || (buckets[key] = { r: 0, g: 0, b: 0, w: 0 });
            bk.r += r * w; bk.g += g * w; bk.b += b * w; bk.w += w;
            totalW += w;
          }
          var raw = [];
          for (var k in buckets) { var bb = buckets[k]; raw.push({ c: [Math.round(bb.r / bb.w), Math.round(bb.g / bb.w), Math.round(bb.b / bb.w)], w: bb.w }); }
          if (!raw.length) { resolve(null); return; }
          raw.sort(function (x, y) { return y.w - x.w; });
          // 2) greedy-merge nearby buckets into clusters (heaviest bucket = center).
          var clusters = [];
          for (var j = 0; j < raw.length; j++) {
            var hit = null;
            for (var m = 0; m < clusters.length; m++) { if (dist(raw[j].c, clusters[m].c) < 48) { hit = clusters[m]; break; } }
            if (hit) hit.w += raw[j].w; else clusters.push({ c: raw[j].c, w: raw[j].w });
          }
          // 3) drop near-white clusters unless they actually dominate — kills the
          //    white "QUICK PRO" wordmark without losing a genuine white frame.
          var kept = clusters.filter(function (cl) {
            var nearWhite = Math.min(cl.c[0], cl.c[1], cl.c[2]) > 200;
            return !(nearWhite && cl.w < totalW * 0.35);
          });
          if (!kept.length) kept = clusters;
          kept.sort(function (x, y) { return y.w - x.w; });
          // 4) take the top up to 3 mutually-distinct, non-trivial frame colors.
          var picked = [];
          for (var n = 0; n < kept.length && picked.length < 3; n++) {
            if (kept[n].w < totalW * 0.08) break;
            var distinct = picked.every(function (p) { return dist(p, kept[n].c) > 50; });
            if (distinct) picked.push(kept[n].c);
          }
          if (!picked.length) picked = [kept[0].c];
          var res = { colors: picked.map(rgb) };
          cache.set(url, res); resolve(res);
        } catch (e) { resolve(null); }
      };
      img.onerror = function () { resolve(null); };
      img.src = img.src = tinyUrl(url);
    });
  }

  function paint(el) {
    if (el.dataset.qpPainted) return;
    el.dataset.qpPainted = '1';
    var m = colorFromMap(el.getAttribute('data-swatch-color'));
    if (m) {
      if (m.image) { el.style.backgroundImage = 'url(' + m.image + ')'; el.style.backgroundSize = 'cover'; el.style.backgroundPosition = 'center'; }
      else { el.style.background = m.color; }
      return;
    }
    var src = el.getAttribute('data-variant-img');
    if (!src) return;
    extract(src).then(function (col) {
      var bg = toBg(col);
      if (bg) el.style.background = bg;
    });
  }

  /* ---- 3. Click a dot -> swap the card image to that variant, mark selected -- */
  function bindSwap(el) {
    if (el.dataset.qpBound) return;
    el.dataset.qpBound = '1';
    el.addEventListener('click', function (e) {
      var vimg = el.getAttribute('data-variant-img');
      var card = el.closest('.qp-card');
      var img = card && card.querySelector('.qp-card__img');
      if (!vimg || !img) return;
      e.preventDefault();
      img.src = vimg.split('?')[0] + '?width=600';
      img.removeAttribute('srcset');
      var sibs = card.querySelectorAll('.qp-swatch');
      for (var i = 0; i < sibs.length; i++) sibs[i].classList.remove('is-selected');
      el.classList.add('is-selected');
    });
  }

  /* ---- 4. PDP: color the theme-native variant-color swatch labels ----------
     Same map-first + extraction logic as the card, so a paint missing from the
     map (e.g. "Green Flower Porcelain") still gets a real color instead of a
     blank label. setProperty(...,'important') beats variant-picker.js's inline
     backgroundColor regardless of which runs first. Display only. */
  function readVariantImages(scope, optPos) {
    var el = scope.querySelector('[id^="productVariants"]'), map = {};
    if (!el) return map;
    try {
      JSON.parse(el.textContent).forEach(function (v) {
        var val = ((v.options && v.options[optPos - 1]) || '').toLowerCase().trim();
        var src = v.featured_image && v.featured_image.src;
        if (val && src && !map[val]) map[val] = src;
      });
    } catch (e) {}
    return map;
  }
  function paintPDP(scope) {
    var nodes = scope.querySelectorAll('.m-product-option--node[data-option-type="color"]');
    if (!nodes.length) return;
    var imgsByPos = {};
    for (var i = 0; i < nodes.length; i++) {
      (function (node) {
        if (node.dataset.qpPdpPainted) return;
        node.dataset.qpPdpPainted = '1';
        var label = node.querySelector('label');
        if (!label) return;
        if (label.hasAttribute('data-qp-native')) { node.dataset.qpPdpPainted = '1'; return; }
        var name = (node.getAttribute('data-value') || '').toLowerCase().trim();
        var pos = node.getAttribute('data-option-position') || '1';
        var m = colorFromMap(name);
        if (m) {
          if (m.image) { label.style.setProperty('background-image', 'url(' + m.image + ')', 'important'); label.style.setProperty('background-size', 'cover', 'important'); }
          else { label.style.setProperty('background', m.color, 'important'); }
          label.classList.remove('option-loading');
          return;
        }
        if (!imgsByPos[pos]) imgsByPos[pos] = readVariantImages(scope, parseInt(pos, 10));
        var src = imgsByPos[pos][name];
        if (!src) return;
        extract(src).then(function (col) {
          var bg = toBg(col);
          if (!bg) return;
          label.style.setProperty('background', bg, 'important');
          label.classList.remove('option-loading');
        });
      })(nodes[i]);
    }
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    paintPDP(scope);
    var dots = scope.querySelectorAll('.qp-swatch');
    for (var k = 0; k < dots.length; k++) bindSwap(dots[k]);
    var toPaint = scope.querySelectorAll('.qp-swatch:not([data-qp-painted])');
    if (!('IntersectionObserver' in window)) { for (var p = 0; p < toPaint.length; p++) paint(toPaint[p]); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { paint(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '200px' });
    for (var q = 0; q < toPaint.length; q++) io.observe(toPaint[q]);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  // Re-color swatches injected AFTER load by AJAX — lazy tab panels
  // (collection.tab-ajax), load-more, storefront filters, quick-view. These fire
  // no Shopify event, so the dots would stay grey. init() is idempotent (painted/
  // bound nodes are skipped), so a debounced re-scan is safe.
  if ('MutationObserver' in window && document.body) {
    var sel = '.qp-swatch, .m-product-option--node[data-option-type="color"]';
    var queued = false;
    new MutationObserver(function (muts) {
      if (queued) return;
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && (n.matches && n.matches(sel) || n.querySelector && n.querySelector(sel))) {
            queued = true;
            (window.requestAnimationFrame || window.setTimeout)(function () { queued = false; init(document); });
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
